(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerLogo = document.querySelector('.header__heading-logo-wrapper img');
    this.scrolledLogoPath = "https://cdn.shopify.com/s/files/1/0656/1618/3458/files/header-logo.png";
    this.defaultLogoPath = "https://cdn.shopify.com/s/files/1/0656/1618/3458/files/header-logo-2.png";
    this.headerIndex = document.querySelector('header');

    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();

    this.updateLogo();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      this.updateLogo();
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      this.updateLogo();
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      this.updateLogo();
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  updateLogo() {
    if (!this.headerLogo || !this.headerIndex) return;

    const template = this.headerIndex.dataset.template;
    const headerWithPages = template === "index";

    if (headerWithPages) {
      if (this.header.classList.contains("scrolled-past-header")) {
        if (this.headerLogo.src !== this.scrolledLogoPath) {
          this.headerLogo.src = this.scrolledLogoPath;
          this.headerLogo.srcset = `${this.scrolledLogoPath} 80w, ${this.scrolledLogoPath} 120w, ${this.scrolledLogoPath} 160w`;
        }
      } else {
        if (this.headerLogo.src !== this.defaultLogoPath) {
          this.headerLogo.src = this.defaultLogoPath;
          this.headerLogo.srcset = `${this.defaultLogoPath} 80w, ${this.defaultLogoPath} 120w, ${this.defaultLogoPath} 160w`;
        }
      }
    } else {
      if (this.headerLogo.src !== this.scrolledLogoPath) {
        this.headerLogo.src = this.scrolledLogoPath;
        this.headerLogo.srcset = `${this.scrolledLogoPath} 80w, ${this.scrolledLogoPath} 120w, ${this.scrolledLogoPath} 160w`;
      }
    }
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-test-address"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let closeButton = document.querySelectorAll('.close');
    let modelNewAddress = document.querySelector('.modelNewAddress');
    let addNewAddress = document.querySelector('.add-new-address');

    addNewAddress.addEventListener('click', () => {
      modelNewAddress.style.display = 'flex';
      closeButton.forEach((btn) => {
        btn.addEventListener('click', () => {
          modelNewAddress.style.display = 'none';
        });
      });
    });

    let addressItems = document.querySelectorAll('.addressItem');

    addressItems.forEach((item) => {
      let closeDetails = item.querySelectorAll('.closeDetails');
      let modalDetails = item.querySelector('.modalDetails');
      let editDetails = item.querySelector('.editDetails');

      editDetails.addEventListener('click', (e) => {
        modalDetails.style.display = 'flex';
        closeDetails.forEach((btn) => {
          btn.addEventListener('click', () => {
            modalDetails.style.display = 'none';
          });
        });
      });
    });
    // Initialize the CountryProvinceSelector for the form
    // new Shopify.CountryProvinceSelector(
    //   'address_country_{{ section.id }}', // Country dropdown ID
    //   'address_province_{{ section.id }}', // Province/State dropdown ID
    //   {
    //     hideElement: 'address_province_container_{{ section.id }}', // Optional: an element to hide when no provinces available
    //   }
    // );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origin-slider"]) return;
  try {
    
  $(document).ready(function () {
    $('#originSlider').slick({
      arrows: true,
      // autoplay: true,
      // autoplaySpeed: 2000,
      slidesToShow: 7,
      slidesToScroll: 1,
      infinite: true,
      prevArrow: '.slider-button-prev',
      nextArrow: '.slider-button-next',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  window.addEventListener('load', () => {
    if (productRecommendationsSection) {
      observer.observe(productRecommendationsSection);
    } else {
      console.error("Element '.product-recommendations' not found in the DOM.");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-login"]) return;
  try {
    
  let resetContainer = document.querySelector('.reset-password-container');
  let forgetButton = document.querySelector('#forget-button');
  let backButton = document.querySelector('#back-to-login');
  let logInContainer = document.querySelector('#login_form');

  forgetButton.addEventListener('click', () => {
    resetContainer.style.display = 'block';
    logInContainer.style.height = '0';
  });
  backButton.addEventListener('click', () => {
    resetContainer.style.display = 'none';
    logInContainer.style.height = '100%';
  });

  } catch(e) { console.error(e); }
})();
})();
